angular.module("Dashboard")
.constant("ENV_VARS", {"apiUrl":"https://api.beers.gatv.es/","imagePath":"https://api.beers.gatv.es/images/","debug":true,"base_href":"/"});
